import React from 'react';
import ReactDOM from 'react-dom';
import { CreateCustomerContainer, LoginContainer, RecoverPasswordContainer, ResetPasswordContainer, } from './routes/pages/login';
const loginRoot = document.getElementById('customer_login_form');
const recoverPasswordRoot = document.getElementById('recover_customer_password_form');
const createCustomerRoot = document.getElementById('create_customer_form');
const resetPasswordRoot = document.getElementById('reset_password_form');
if (loginRoot) {
    ReactDOM.render(React.createElement(LoginContainer, null), loginRoot);
}
if (recoverPasswordRoot) {
    let success;
    if (recoverPasswordRoot.dataset.success) {
        success = recoverPasswordRoot.dataset.success == 'true';
    }
    ReactDOM.render(React.createElement(RecoverPasswordContainer, { success: success }), recoverPasswordRoot);
}
if (createCustomerRoot) {
    let serverErrors;
    if (createCustomerRoot.dataset.errors &&
        JSON.parse(createCustomerRoot.dataset.errors)) {
        serverErrors = Object.entries(JSON.parse(createCustomerRoot.dataset.errors))
            .map(([key, value]) => {
            return [
                key.replace(/_([a-z])/g, m => m[1].toUpperCase()),
                new DOMParser().parseFromString(value, 'text/html')
                    .documentElement.textContent,
            ];
        })
            .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
        }, {});
    }
    ReactDOM.render(React.createElement(CreateCustomerContainer, { serverErrors: serverErrors }), createCustomerRoot);
}
if (resetPasswordRoot) {
    let serverErrors;
    if (resetPasswordRoot.dataset.errors &&
        JSON.parse(resetPasswordRoot.dataset.errors)) {
        serverErrors = Object.entries(JSON.parse(resetPasswordRoot.dataset.errors))
            .map(([key, value]) => {
            return [
                key.replace(/_([a-z])/g, m => m[1].toUpperCase()),
                new DOMParser().parseFromString(value, 'text/html')
                    .documentElement.textContent,
            ];
        })
            .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
        }, {});
    }
    ReactDOM.render(React.createElement(ResetPasswordContainer, { serverErrors: serverErrors }), resetPasswordRoot);
}
